/**
 * Table of Contents for Blog V1 Articles
 * Auto-generated from section headings
 */

import React, { useState } from 'react';
import { getTitlePlainText } from '../../utils/titleFormat';

export const BlogTableOfContents = ({ sections = [] }) => {
  const [isOpen, setIsOpen] = useState(true);

  const headings = sections
    .filter(s => {
      if (!s.heading) return false;
      // Handle both string and rich text (object) formats
      const headingText = typeof s.heading === 'string' ? s.heading : getTitlePlainText(s.heading);
      return headingText && headingText.trim().length > 0;
    })
    .map((s, index) => {
      const headingText = typeof s.heading === 'string' ? s.heading : getTitlePlainText(s.heading);
      return {
        id: s.id || `section-${index}`,
        text: headingText,
        level: 2
      };
    });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId) || document.querySelector(`[data-section-id="${sectionId}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Update URL hash without triggering scroll
      window.history.replaceState(null, '', `#${sectionId}`);
    }
  };

  return (
    <div className="bg-[#F9FAFB] border border-[#E5E7EB] rounded-lg p-4">
      {/* Mobile: Collapsible */}
      <div className="lg:hidden">
        <button
          onClick={() => setIsOpen(!isOpen)}
          aria-expanded={isOpen}
          aria-controls="toc-nav-mobile"
          className="w-full flex justify-between items-center text-left"
        >
          <h3 className="text-sm font-semibold text-[#111827]">Table of Contents</h3>
          <svg
            className={`w-5 h-5 text-[#6B7280] transition-transform ${isOpen ? 'transform rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {isOpen && (
          <nav id="toc-nav-mobile" aria-label="Table of contents" className="mt-3 space-y-2">
            {headings.length > 0 ? (
              headings.map((heading) => (
                <a
                  key={heading.id}
                  href={`#${heading.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(heading.id);
                  }}
                  className="block text-sm text-[#1E40AF] hover:text-[#1e3a8a] hover:underline text-left"
                >
                  {heading.text}
                </a>
              ))
            ) : (
              <p className="text-sm text-[#6B7280]">No sections with headings available.</p>
            )}
          </nav>
        )}
      </div>

      {/* Desktop: Always visible */}
      <div className="hidden lg:block">
        <h3 className="text-sm font-semibold text-[#111827] mb-3">Table of Contents</h3>
        <nav aria-label="Table of contents" className="space-y-2">
          {headings.length > 0 ? (
            headings.map((heading) => (
              <a
                key={heading.id}
                href={`#${heading.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(heading.id);
                }}
                className="block text-sm text-[#1E40AF] hover:text-[#1e3a8a] hover:underline text-left"
              >
                {heading.text}
              </a>
            ))
          ) : (
            <p className="text-sm text-[#6B7280]">No sections with headings available.</p>
          )}
        </nav>
      </div>
    </div>
  );
};

export default BlogTableOfContents;
